import { access_control_list_tab, managers_tab } from '../../../../../../views/team/managers';

export default {
  tabs: {
    [managers_tab]: 'Managere',
    [access_control_list_tab]: 'Adgangskontrol',
  },
};
